import axios from "axios";
import {BASE_URL} from "./consts";

export const getBlocksOfStorage = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${BASE_URL}/api/storage-blocks`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting blocks of storage:", error);
		throw error;
	}
};

export const createBlockOfStorage = async (newBlock) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `POST`,
			url: `${BASE_URL}/api/blocks`,
			data: {name: newBlock.name, is_active: newBlock.is_active},
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error creating block:", error);
		throw error;
	}
};

export const editBlockOfStorage = async (blockId, unique_id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `PUT`,
			url: `${BASE_URL}/api/storage-blocks`,
			data: {blockId, unique_id},
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error editing blocks of storage:", error);
		throw error;
	}
};

export const deleteBlockOfStorage = async (id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `DELETE`,
			url: `${BASE_URL}/api/blocks/${id}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error deleting block:", error);
		throw error;
	}
};
